
import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, LayoutGrid, Globe, BookOpen } from 'lucide-react';
import SeoMetadata from "@/components/common/SeoMetadata";

const SivustokarttaPage = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <SeoMetadata
        title="Sivustokartta - Lainasampo.fi"
        description="Selaa kaikkia Lainasampo.fi sivuston sivuja sivustokartasta."
        keywords={["sivustokartta", "sitemap", "lainasampo", "kaikki sivut"]}
        canonicalUrl="https://lainasampo.fi/sivustokartta"
      />

      <h1 className="text-3xl font-bold mb-6 text-center lg:text-left">Sivustokartta</h1>
      <p className="text-lg mb-8 text-center lg:text-left">
        Tältä sivulta löydät linkit kaikkiin Lainasampo.fi:n sivuihin.
      </p>

      {/* 1. PÄÄSIVUT - Tärkeimmät ensiksi */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold mb-4 flex items-center">
            <LayoutGrid className="h-5 w-5 mr-2 text-blue-600" />
            Pääsivut
          </h2>
          <ul className="space-y-2">
            <li><Link to="/" className="text-blue-600 hover:underline">Etusivu</Link></li>
            <li><Link to="/kilpailuta" className="text-blue-600 hover:underline">Kilpailuta laina</Link></li>
            <li><Link to="/lainatuotteet" className="text-blue-600 hover:underline">Lainatuotteet</Link></li>
            <li><Link to="/artikkelit" className="text-blue-600 hover:underline">Artikkelit</Link></li>
            <li><Link to="/meista" className="text-blue-600 hover:underline">Tietoa meistä</Link></li>
            <li><Link to="/yhteystiedot" className="text-blue-600 hover:underline">Ota yhteyttä</Link></li>
            <li><Link to="/ukk" className="text-blue-600 hover:underline">Usein kysytyt kysymykset</Link></li>
            <li><Link to="/lainat/ulosottolaskuri" className="text-blue-600 hover:underline">Ulosottolaskuri</Link></li>
            <li><Link to="/tietosuojaseloste" className="text-blue-600 hover:underline">Tietosuojaseloste</Link></li>
            <li><Link to="/kayttoehdot" className="text-blue-600 hover:underline">Käyttöehdot</Link></li>
          </ul>
        </div>

        {/* 2. LAINATUOTTEET - Aakkosjärjestyksessä */}
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold mb-4 flex items-center">
            <FileText className="h-5 w-5 mr-2 text-blue-600" />
            Lainatuotteet
          </h2>
          <ul className="space-y-2">
            <li><Link to="/lainat/asuntolaina" className="text-blue-600 hover:underline">Asuntolaina</Link></li>
            <li><Link to="/lainat/autolaina" className="text-blue-600 hover:underline">Autolaina</Link></li>
            <li><Link to="/lainat/caravanrahoitus" className="text-blue-600 hover:underline">Caravanrahoitus</Link></li>
            <li><Link to="/lainat/haalaina" className="text-blue-600 hover:underline">Häälaina</Link></li>
            <li><Link to="/lainat/joustoluotto" className="text-blue-600 hover:underline">Joustoluotto</Link></li>
            <li><Link to="/lainat/kulutusluotto" className="text-blue-600 hover:underline">Kulutusluotto</Link></li>
            <li><Link to="/lainat/lomalaina" className="text-blue-600 hover:underline">Lomalaina</Link></li>
            <li><Link to="/lainat/mokkilaina" className="text-blue-600 hover:underline">Mökkilaina</Link></li>
            <li><Link to="/lainat/moottoripyoralaina" className="text-blue-600 hover:underline">Moottoripyörälaina</Link></li>
            <li><Link to="/lainat/pienkonelaina" className="text-blue-600 hover:underline">Pienkonelaina</Link></li>
            <li><Link to="/lainat/pienlainat-luottokortit" className="text-blue-600 hover:underline">Pienlainat & Luottokortit</Link></li>
            <li><Link to="/lainat/pikalaina" className="text-blue-600 hover:underline">Pikalaina</Link></li>
            <li><Link to="/lainat/remonttilaina" className="text-blue-600 hover:underline">Remonttilaina</Link></li>
            <li><Link to="/lainat/venelaina" className="text-blue-600 hover:underline">Venelaina</Link></li>
            <li><Link to="/lainat/yhdistelylaina" className="text-blue-600 hover:underline">Yhdistelylaina</Link></li>
            <li><Link to="/lainat/yrityslaina" className="text-blue-600 hover:underline">Yrityslaina</Link></li>
          </ul>
        </div>
      </div>

      {/* 3. ARTIKKELIT KATEGORIOITTAIN */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold mb-4 flex items-center">
            <BookOpen className="h-5 w-5 mr-2 text-blue-600" />
            Laina-oppaat
          </h2>
          <ul className="space-y-2">
            <li><Link to="/artikkelit/lainan-ottamisen-opas-2025" className="text-blue-600 hover:underline">Lainan ottamisen opas 2025</Link></li>
            <li><Link to="/artikkelit/miten-valita-oikea-laina-eri-tilanteisiin-2025" className="text-blue-600 hover:underline">Lainojen vertailu 2025</Link></li>
            <li><Link to="/artikkelit/yhdistelylaina-opas-lainojen-yhdistamiseen" className="text-blue-600 hover:underline">Yhdistelylaina-opas</Link></li>
            <li><Link to="/artikkelit/kulutusluottojen-vertailu-saasta-korkokuluissa" className="text-blue-600 hover:underline">Kulutusluottojen vertailu</Link></li>
            <li><Link to="/artikkelit/venelainaopas-nain-rahoitat-unelmiesi-veneen" className="text-blue-600 hover:underline">Venelainaopas</Link></li>
            <li><Link to="/artikkelit/vastuullinen-lainaaminen-nain-teet-kestavia-rahoituspaatoksia" className="text-blue-600 hover:underline">Vastuullinen lainaaminen</Link></li>
          </ul>
          
          <h3 className="text-lg font-semibold mb-3 mt-6">Markkinakatsaukset</h3>
          <ul className="space-y-2">
            <li><Link to="/artikkelit/korkojen-nousu-ja-inflaatio" className="text-blue-600 hover:underline">Korkojen nousu ja inflaatio</Link></li>
            <li><Link to="/artikkelit/asuntomarkkinoiden-ennuste-2025-kannattaako-nyt-ostaa-vai-myyda" className="text-blue-600 hover:underline">Asuntomarkkinoiden ennuste 2025</Link></li>
            <li><Link to="/artikkelit/nain-korot-vaikuttavat-lainan-kokonaiskustannuksiin" className="text-blue-600 hover:underline">Korot ja kokonaiskustannukset</Link></li>
          </ul>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold mb-4 flex items-center">
            <BookOpen className="h-5 w-5 mr-2 text-blue-600" />
            Yrittäjän rahoitus
          </h2>
          <ul className="space-y-2">
            <li><Link to="/artikkelit/yrittajan-rahoitusopas-2025-nain-haet-ja-saat-yrityslainaa" className="text-blue-600 hover:underline">Yrittäjän rahoitusopas 2025</Link></li>
            <li><Link to="/artikkelit/pienyrittajan-rahoitusopas-2025-parhaat-rahoitusvaihtoehdot-eri-tilanteisiin" className="text-blue-600 hover:underline">Pienyrittäjän rahoitusopas</Link></li>
          </ul>

          <h3 className="text-lg font-semibold mb-3 mt-6">Erikoisaiheet</h3>
          <ul className="space-y-2">
            <li><Link to="/artikkelit/ulosoton-abc-kaikki-mita-sinun-tulee-tietaa-ulosotosta" className="text-blue-600 hover:underline">Ulosoton ABC</Link></li>
            <li><Link to="/artikkelit/hauska-lomalaina-rahoita-unelmalomasi-suomen-parhaisiin-luontokohteisiin" className="text-blue-600 hover:underline">Lomalaina luontokohteisiin</Link></li>
            <li><Link to="/artikkelit/caravan-matkailu-suomessa-2025" className="text-blue-600 hover:underline">Caravan-matkailu 2025</Link></li>
          </ul>

          <div className="mt-6 pt-4 border-t border-gray-200">
            <Link to="/artikkelit" className="text-blue-600 hover:underline font-semibold">
              → Kaikki artikkelit
            </Link>
          </div>
        </div>
      </div>

      {/* 4. KIELIVERSIOT JA TEKNISET SIVUT */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold mb-4 flex items-center">
            <Globe className="h-5 w-5 mr-2 text-blue-600" />
            Kieliversiot
          </h2>
          <ul className="space-y-2">
            <li><Link to="/en" className="text-blue-600 hover:underline">English</Link></li>
            <li><Link to="/sv" className="text-blue-600 hover:underline">Svenska</Link></li>
            <li><Link to="/ar" className="text-blue-600 hover:underline">العربية</Link></li>
            <li><Link to="/he" className="text-blue-600 hover:underline">עברית</Link></li>
          </ul>

          <h3 className="text-lg font-semibold mb-3 mt-6">Kansainväliset sivut</h3>
          <ul className="space-y-2">
            <li><Link to="/en/apply" className="text-blue-600 hover:underline">English Application</Link></li>
            <li><Link to="/en/products" className="text-blue-600 hover:underline">English Products</Link></li>
            <li><Link to="/en/info" className="text-blue-600 hover:underline">English Information</Link></li>
            <li><Link to="/sv/apply" className="text-blue-600 hover:underline">Swedish Application</Link></li>
            <li><Link to="/sv/products" className="text-blue-600 hover:underline">Swedish Products</Link></li>
            <li><Link to="/ar/apply" className="text-blue-600 hover:underline">Arabic Application</Link></li>
            <li><Link to="/he/apply" className="text-blue-600 hover:underline">Hebrew Application</Link></li>
          </ul>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold mb-4 flex items-center">
            <FileText className="h-5 w-5 mr-2 text-blue-600" />
            Tekniset sivut
          </h2>
          <ul className="space-y-2">
            <li><a href="/sitemap.xml" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">XML-sivustokartta</a></li>
            <li><a href="/robots.txt" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">Robots.txt</a></li>
            <li><a href="/article-sitemap.xml" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">Artikkeli-sivustokartta</a></li>
          </ul>

          <div className="mt-6 p-4 bg-blue-50 rounded-lg">
            <p className="text-sm text-gray-600">
              <strong>Huomaa:</strong> Sivustokartta päivittyy automaattisesti kun lisäämme uusia sivuja tai artikkeleita. 
              Jos et löydä etsimääsi sivua, käytä sivuston hakutoimintoa tai ota yhteyttä.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SivustokarttaPage;
